<template>
    <div class="followup">
        <Header :code="code">Donner Suite</Header>
        <v-container>
            <v-row>
                <v-col cols='12'>
                    <v-expansion-panels flat tile accordion>
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Planifier un rappel
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-menu
                                            ref="rappel"
                                            v-model="rappel"
                                            :close-on-content-click="false"
                                            :return-value.sync="date_rappel"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="formatDateRappel"
                                                label="Date de rappel"
                                                prepend-icon="mdi-calendar"
                                                readonly
                                                hide-details
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                            </template>
                                            <v-date-picker
                                            v-model="date_rappel"
                                            locale="fr-fr"
                                            no-title
                                            scrollable
                                            @change="$refs.rappel.save(date_rappel)"
                                            >
                                            </v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-menu
                                            ref="heure"
                                            v-model="heure"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            :return-value.sync="heure_rappel"
                                            transition="scale-transition"
                                            offset-y
                                            max-width="290px"
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                                v-model="heure_rappel"
                                                label="Heure de rappel"
                                                prepend-icon="mdi-clock-time-four-outline"
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                            ></v-text-field>
                                            </template>
                                            <v-time-picker
                                            v-if="heure"
                                            :format="format"
                                            :allowed-hours="[8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20]"
                                            v-model="heure_rappel"
                                            full-width
                                            @click:minute="$refs.heure.save(heure_rappel)"
                                            ></v-time-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-textarea
                                            name="input-7-1"
                                            label="Commentaire"
                                            v-model="rappelCommentaire"
                                            hide-details 
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="12" class="errorFollowUp" v-if="errorRappel">   
                                        Merci de renseigner une date et une heure pour planifier un rappel
                                    </v-col>
                                     <v-col cols="12" class="text-right">
                                        <v-btn
                                        color="primary"
                                        depressed
                                        @click="callbackLead"
                                        >
                                        Planifier
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Abandonner le lead
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-row dense>
                                    <v-col cols="12">
                                        <v-select v-model="abandonMotif" :items="abandonItems" label="Sélectionnez le motif" hide-details></v-select>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-textarea
                                            name="input-7-1"
                                            label="Commentaire"
                                            v-model="abandonCommentaire"
                                            hide-details 
                                        ></v-textarea>
                                    </v-col>
                                    <v-col cols="12" class="errorFollowUp" v-if="errorAbandon">   
                                        Merci de renseigner un motif d'abandon
                                    </v-col>
                                    <v-col cols="12" class="text-right">
                                        <v-btn
                                        color="primary"
                                        depressed
                                        @click="preAbandonLead"
                                        >
                                        Valider
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog
        v-model="confirmRappel"
        width="300"
        >
            <v-card>
                <v-card-title class="headline" style='color: #eb566b'>
                Rappel planifié !
                </v-card-title>

                <v-card-text>
                    Le rappel de ce lead a bien été planifié.
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn color="primary" depressed @click="$router.push({name: 'Details', params: { code: code, id: leadDetail.id }})">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
        v-model="askAbandon"
        persistent
        width="300"
        >
            <v-card>
                <v-card-title class="headline" style='color: #eb566b'>
                    Abandon
                </v-card-title>

                <v-card-text>
                   Abandonner le lead provoquera la suppression de son rendez-vous. Êtes-vous sur ?
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn color="error" depressed @click="askAbandon = false">
                        Non
                    </v-btn>
                    <v-btn color="primary" depressed @click="abandonLead">
                        Oui
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
        v-model="confirmAbandon"
        width="300"
        >
            <v-card>
                <v-card-title class="headline" style='color: #eb566b'>
                    Abandon
                </v-card-title>

                <v-card-text>
                    Le lead a bien été abandonné.
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn color="primary" depressed @click="$router.push({name: 'Details', params: { code: code, id: leadDetail.id }})">
                        OK
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import Header from '@/components/Header'
export default {
    name:'FollowUp',
    props: ['id', 'code'],
    components: {
        Header,
    },
    data() {
        return {
            leadDetail: {},
            projet: {},
            rappel:false,
            heure: false,
            askAbandon: false,
            heure_rappel:'',
            date_rappel:"",
            rappelCommentaire : "",
            format: '24hr',
            errorRappel: false,
            confirmRappel: false,
            abandonCommentaire:"",
            abandonMotif:"",
            abandonItems: [
                "Contact erroné", 
                "Véhicule souhaité non disponible", 
                "Changera dans plus d'un an", 
                "LLD/LOA trop récente", 
                "Déçu par la marque",
                "Déçu par le point de vente",
                "Pas le budget",
                "Concurrence",
                "Barrage secrétaire",
                "Déménagement",
                "Pas besoin véhicule",
                "Sénior",
                "Plus de permis",
                "Employé point de vente",
                "Voiture de fonction",
                "Pas disponible pendant l'opération"
            ],
            errorAbandon: false,
            confirmAbandon:false
        }
    },
    computed: {
        formatDateRappel(){
            return this.transformDate(this.date_rappel)
        },
    },
    methods: {
        preAbandonLead(){
            if(this.abandonMotif == ''){
                this.errorAbandon = true;
            } else {
                this.askAbandon = true;
            }
        },
        abandonLead() {
            const payload = {
                id_utilisateur_externe: this.$store.state.user.id,
                code_lead: this.leadDetail.code_lead,
                motif: this.abandonMotif,
                commentaire: this.abandonCommentaire
            }
            this.$store.dispatch('setLoader', true).then((e) => {
                this.askAbandon = false;
                this.$store.dispatch('abandonLead', payload).then((e) => {
                    this.$store.dispatch('getLeadProjets', {codeProjet: this.code}).then((e)=> {
                        const lead = this.$store.state.leads.find(e => e.id == this.id);
                        this.$store.dispatch('getDetailLead', lead.code_lead).then((e) => {
                            this.$store.dispatch('setLoader', false).then((e) => {
                                this.confirmAbandon = true
                            })
                        }) 
                    })
                });
            })
        },
        callbackLead() {
            if(this.date_rappel == '' || this.heure_rappel == ''){
                this.errorRappel = true;
            } else {
                let rappel = this.formatDateRappel+" "+this.heure_rappel
                const payload = {
                    id_utilisateur_externe: this.$store.state.user.id,
                    code_lead: this.leadDetail.code_lead,
                    date_rappel: rappel,
                    commentaire: this.rappelCommentaire
                }
                this.$store.dispatch('setLoader', true).then((e) => {
                    this.$store.dispatch('addRappel', payload).then((e) => {
                         this.$store.dispatch('setLoader', false).then((e) => {
                             this.confirmRappel = true
                         })
                    });
                })
                
            }
        },
        transformDate(date) {
            if (!date) return null
            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },
        parseDate(date) {
            if (!date) return null
            const [day, month, year] = date.split('/')
            return `${year}-${month}-${day}`
        },
    },
    created() {
        if(this.$store.state.loader){
            this.$store.dispatch('setLoader', false)
        }
        this.leadDetail = this.$store.state.leads.find((e)=> e.id == this.id);    
        this.projet = this.$store.state.projets.find((e) => {
            return e.code_projet == this.code
        })
    },
}
</script>
<style lang="scss">
    .followup {
        padding-top:8vh;
        .v-expansion-panel {
            margin-bottom:10px;
        }
        .errorFollowUp {
            font-size:0.8em;
            color:red;
        }
    }
    
</style>